/**
 * Section A3 Service
 * A.3.政策符合性說明 API 服務
 *
 * 注意: axios 攔截器會自動從 localStorage 讀取 txn_token 並添加到所有請求的 header
 * Service 層不需要手動傳遞 txn_token 參數
 */

import axios from '../api/axios';
import { SectionA3, SectionA3Update } from '../types/section_a3';

const BASE_URL = '/api/section-a3';

/**
 * 根據專案 ID 取得 A.3 資料
 * axios 攔截器會自動添加 X-Txn-Token header
 */
export const getSectionA3ByProject = async (projectId: number): Promise<SectionA3 | null> => {
  const response = await axios.get<SectionA3>(`${BASE_URL}/by-project/${projectId}`);
  return response.data;
};

/**
 * 更新或建立 A.3 資料
 * 如果不存在會自動建立
 * axios 攔截器會自動添加 X-Txn-Token header
 */
export const updateSectionA3 = async (projectId: number, data: SectionA3Update): Promise<SectionA3> => {
  const response = await axios.put<SectionA3>(`${BASE_URL}/${projectId}`, data);
  return response.data;
};

/**
 * 刪除 A.3 資料
 * axios 攔截器會自動添加 X-Txn-Token header
 */
export const deleteSectionA3 = async (projectId: number): Promise<void> => {
  await axios.delete(`${BASE_URL}/${projectId}`);
};

export default {
  getSectionA3ByProject,
  updateSectionA3,
  deleteSectionA3
};
